var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mainLink)?_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{ name: 'main' }}},[_c('p',{staticClass:"logo__text",class:_vm.bindClass,style:(_vm.fontSize)},[_vm._v("#BUY NOW")])]):_c('p',{staticClass:"logo__text",class:_vm.bindClass,style:(_vm.fontSize)},[_vm._v("#BUY NOW")])
}
var staticRenderFns = []

export { render, staticRenderFns }